import moment from 'moment-timezone';
import 'moment/locale/es';

const momentum = (date: moment.MomentInput = new Date()): moment.Moment => moment(date).tz('Europe/Madrid').locale('es');

export default momentum;
